import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";

const NotFound = () => {
  return (
    <main className="home-shell flex min-h-screen items-center px-4 pb-14 pt-28 sm:px-6">
      <section className="home-section w-full border-none px-0 py-0">
        <div className="home-container">
          <div className="home-card-strong mx-auto max-w-2xl p-8 text-center sm:p-12">
            <span className="section-kicker">Error 404</span>
            <h1 className="home-title mt-4 text-4xl font-bold sm:text-6xl">Page Not Found</h1>
            <p className="mt-4 text-sm home-muted sm:text-base">
              The page you're looking for doesn't exist or may have been moved.
            </p>
            <Link
              to="/"
              className="home-btn-primary mt-8 inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold"
            >
              <FaHome /> Back to Home
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default NotFound;
